<template>
  <div id="faq-page">
    <div class="vx-row">
      <!-- FAQ COL -->
      <div class="vx-col w-full md:w-3/5 lg:w-3/4 mt-12 md:mt-0">
        <!-- <vx-card ref="mapCard"> -->
        <vs-progress
          indeterminate
          color="primary"
          v-if="isLoading == true"
        ></vs-progress>
        <div id="map" ref="map"></div>

        <!--    </vx-card> -->
      </div>

      <div class="vx-col w-full md:w-2/5 lg:w-1/4 mt-12 md:mt-0">
        <vx-card v-if="selectedUnitDetails != null">
          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="8"
              ><h3>
                <b>{{ selectedUnitDetails.assetName }} </b>
              </h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="3"
            >
            </vs-col>
          </vs-row>
          <vs-progress
            indeterminate
            color="primary"
            v-if="isLoading2 == true"
          ></vs-progress>
          <vs-list-item
            icon="schedule"
            :title="selectedUnitDetails.lastUpdated"
            subtitle="Updated Time"
          ></vs-list-item>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
                icon-pack="feather"
                icon="icon-check-circle"
                :title="selectedUnitDetails.status"
                subtitle="Status"
              ></vs-list-item>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
              <vs-list-item
                icon="signal_cellular_4_bar"
                :title="selectedUnitDetails.gps"
                subtitle="GPS"
              ></vs-list-item>
            </vs-col>
          </vs-row>

          <vs-list-item
            icon="location_on"
            :title="selectedUnitDetails.address"
            subtitle="Location"
          ></vs-list-item>
        </vx-card>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import vSelect from 'vue-select';
import moment from 'moment';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { Query, Predicate } from '@syncfusion/ej2-data';

export default {
  data() {
    return {
      heatmapLayer: null,
      hideHeatmap: false,
      tabFocus: true,
      webMapLocal: localStorage.getItem('webmap-mapview-maptype') || 'roadmap',
      webMapShowPOILocal:
        localStorage.getItem('webmap-mapview-showpoi') || true,
      poiReferences: [],
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      streetviewSettings: false,
      mapPOIData: JSON.parse(localStorage.getItem('mapPOIData')),
      geoPOIData: JSON.parse(localStorage.getItem('geoPOIData')),
      fields: { groupBy: 'assetGroup', text: 'assetName', value: 'assetId' },
      isLoading: true,
      isLoading2: false,
      currentDisplayedAssetId: null,
      currentDisplayedLoadedOnce: false,
      selected: {
        assetName: '',
      },
      chartLoaded: false,
      popupActive: false,
      chartLoaded2: false,
      popupActive2: false,
      filterType: 'All',
      loader: null,
      map: null,
      firstLoad: true,
      streetMap: null,
      markerCluster: null,
      units: [],
      listener: null,
      singleListener: null,
      selectedUnits: [],
      stat: null,
      mapMarkerData: [],
      changeDisplay: false,
      selectedUnitDetails: null,
      selectedUnitDisplay: false,
      locations: null,
      loadStreetView: false,
      defaultMapClass: 'vx-col w-full md:w-5/5 lg:w-4/4 mt-12 md:mt-0',
      popup: null,
      gmarkers: [],
      dt: this.$route.params.dt,
    };
  },
  components: {
    vSelect,
    Loader,
    MarkerClusterer,
    moment,
    MultiSelectPlugin,
    Query,
    Predicate,
  },
  mounted() {
    const self = this;
    self.loader = new Loader(this.$loader);
    self
      .decryptObject(self.dt, 'super-secret-key')
      .then((decryptedObject) => {
        let dt = decryptedObject;
        let currTimeInMs = Date.now();

        if (currTimeInMs > dt.expiryTimeInMs) {
          self.isLoading = false;
          return alert(
            'Link in invalid / has expired. Kindly request a new link!',
          );
        } else {
          self.loader.load().then(() => {
            self.map = new google.maps.Map(self.$refs.map, {
              center: { lat: 3.910187, lng: 102.119262 },
              zoom: 14,
              gestureHandling: 'greedy',
              mapTypeId: self.webMapLocal,
            });

            self.selectedUnits.push(Number(dt.assetId));
            self.isLoading = false;
          });
        }
      })
      .catch((e) => {
        self.isLoading = false;
        return alert(
          'Link in invalid / has expired. Kindly request a new link!',
        );
      });
  },
  watch: {
    selectedUnits(val) {
      if (this.listener) {
        clearTimeout(this.listener);
      }
      this.realtimeListener();
    },
  },
  methods: {
    async decryptObject(encryptedString, secretKey) {
      // Convert the URL-safe Base64 string to a regular Base64 string
      const encoder = new TextEncoder();
      const base64String = encryptedString
        .replace(/-/g, '+')
        .replace(/_/g, '/')
        .padEnd(
          encryptedString.length + ((4 - (encryptedString.length % 4)) % 4),
          '=',
        );

      const decoder = new TextDecoder();

      // Convert the secret key to ArrayBuffer
      const keyBuffer = await crypto.subtle.importKey(
        'raw',
        encoder.encode(secretKey),
        'AES-GCM',
        true,
        ['decrypt'],
      );

      // Extract IV and encrypted data from the Base64 string
      const arrayBuffer = new Uint8Array(
        [...atob(base64String)].map((char) => char.charCodeAt(0)),
      );

      // Separate IV and encrypted data
      const iv = arrayBuffer.slice(0, 12);
      const encryptedData = arrayBuffer.slice(12);

      // Decrypt the data
      const decryptedData = await crypto.subtle.decrypt(
        { name: 'AES-GCM', iv },
        keyBuffer,
        encryptedData,
      );

      // Convert the decrypted data to an object
      const decryptedObject = JSON.parse(decoder.decode(decryptedData));

      return decryptedObject;
    },
    filtering(args) {
      const self = this;
      const searchData = self.unitSelection;
      let query = new Query();
      let predicate = new Predicate('assetName', 'contains', args.text, true);
      predicate = predicate.or('assetGroup', 'contains', args.text, true);
      query = args.text != '' ? query.where(predicate) : query;

      args.updateData(searchData, query);
    },
    filterTypeChange(type) {
      const self = this;
      self.removeMarkers();
      self.filterType = type;
      self.gmarkers = [];
      const markers = self.mapMarkerData.map((data, i) => {
        if (self.filterType == 'All' || self.filterType == data.status) {
          const marker = new google.maps.Marker({
            position: { lat: data.lat, lng: data.lng },
            label: {
              text: data.name,
              color: 'black',
              fontSize: '14px',
              align: 'center',
              fontWeight: 'bold',
            },
            icon: {
              labelOrigin: new google.maps.Point(0, 7),
              //   anchor:new google.maps.Point(15, 30),
              path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
              scale: 5,
              strokeWeight: 3,
              strokeColor: data.color,
              rotation: data.rotation,
            },
            metadata: { assetId: data.assetId },
            map: self.$refs.map,
          });
          self.gmarkers.push(marker);
          google.maps.event.addListener(marker, 'click', function (evt) {
            if (self.singleListener) {
              clearTimeout(self.singleListener);
            }
            self.map.panTo(marker.position);
            self.map.setZoom(16);
            self.firstLoad = true;
            self.displayDetails(marker.metadata.assetId);
          });
          return marker;
        } else {
          return false;
        }
      });

      self.markerCluster = new MarkerClusterer({
        markers: self.gmarkers,
      });
      self.markerCluster.setMap(self.map);
    },
    realtimeListener() {
      // console.log('called');
      const self = this;
      self.isLoading = true;

      if (self.selectedUnitDisplay == false) {
        self.selectedUnitDetails = null;
        self.defaultMapClass = 'vx-col w-full md:w-5/5 lg:w-4/4 mt-12 md:mt-0';
        self.loadStreetView = false;
      }

      //   if(self.singleListener!=null){ clearTimeout(self.singleListener) }

      if (self.selectedUnits.length == 0) {
        self.isLoading = false;
        self.removeMarkers();
        self.selectedUnitDetails = null;
        self.selectedUnitDetails = null;
        self.stat = null;
        clearTimeout(self.singleListener);
        self.defaultMapClass = 'vx-col w-full md:w-5/5 lg:w-4/4 mt-12 md:mt-0';
        self.loadStreetView = false;
        self.map.panTo({ lat: 3.910187, lng: 102.119262 });
        if (self.heatmapLayer != null) {
          self.heatmapLayer.setMap(null);
          self.hideHeatmap = false;
        }
        return self.map.setZoom(8);
      }
      if (self.selectedUnits.length != 0) {
        self.$http
          .post(`dashboardListener/${1}`, {
            selectedUnits: self.selectedUnits,
          })
          .then(function (response) {
          console.log(response)
            if (response.status == 200 && response.data.success) {
              self.removeMarkers();
              self.mapMarkerData = response.data.mapMarkerData;
              self.stat = response.data.stat;
              const i = 0;
              self.gmarkers = [];
              const markers = self.mapMarkerData.map((data, i) => {
                if (
                  self.filterType == 'All' ||
                  self.filterType == data.status
                ) {
                  const marker = new google.maps.Marker({
                    position: { lat: data.lat, lng: data.lng },
                    label: {
                      text: data.name,
                      color: 'black',
                      fontSize: '14px',
                      align: 'center',
                      fontWeight: 'bold',
                    },
                    icon: {
                      labelOrigin: new google.maps.Point(0, 7),
                      //   anchor:new google.maps.Point(15, 30),
                      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                      scale: 5,
                      strokeWeight: 3,
                      strokeColor: data.color,
                      rotation: data.rotation,
                    },
                    metadata: { assetId: data.assetId },
                    map: self.map,
                  });
                  self.gmarkers.push(marker);
                  if (i == 0 && self.singleListener == null)
                    self.map.panTo(marker.position);
                  google.maps.event.addListener(
                    marker,
                    'click',
                    function (evt) {
                      if (self.singleListener) {
                        clearTimeout(self.singleListener);
                      }
                      self.map.panTo(marker.position);
                      self.map.setZoom(16);
                      self.displayDetails(marker.metadata.assetId);
                    },
                  );
                  i = 1;
                  return marker;
                }
              });

              self.markerCluster = new MarkerClusterer({
                markers: self.gmarkers,
              });
              self.markerCluster.setMap(self.map);
              if (self.selectedUnits.length == 1) {
                if (self.singleListener) {
                  clearTimeout(self.singleListener);
                }

                self.displayDetails(self.mapMarkerData[0].assetId);
              }
              self.isLoading = false;
              self.listener = setTimeout(() => {
                self.realtimeListener();
              }, 60000);
            } else if (response.data.error) {
            } else {
            }
          })
          .catch(function (error) {});
      }
    },
    removeMarkers() {
      const self = this;
      if (self.gmarkers.length != 0) {
        self.markerCluster.setMap(null);
        for (let i = 0; i < self.gmarkers.length; i++) {
          self.gmarkers[i].setMap(null);
        }
      }
    },

    displayDetails(assetId) {
      // console.log('single called');

      const self = this;
      if (
        self.selectedUnitDetails != null &&
        assetId != self.selectedUnitDetails.assetId &&
        self.heatmapLayer != null
      ) {
        self.heatmapLayer.setMap(null);
        self.hideHeatmap = false;
      }
      self.isLoading2 = true;
      if (self.selectedUnitDisplay == false) {
        self.selectedUnitDetails = null;
      }
      self.$http
        .post(`singleUnitDetails/${assetId}/${1}`, {
          geoPOIData: [1094],
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.selectedUnitDetails = response.data.unitDetails;
            self.defaultMapClass =
              'vx-col w-full md:w-3/5 lg:w-3/4 mt-12 md:mt-0';

            self.map.panTo({
              lat: self.selectedUnitDetails.lat,
              lng: self.selectedUnitDetails.lng,
            });
            if (
              self.streetviewSettings == true &&
              self.tabFocus == true &&
              self.firstLoad == true &&
              (self.selectedUnitDetails.status == 'Moving' ||
                (self.currentDisplayedAssetId != assetId &&
                  self.currentDisplayedLoadedOnce == false &&
                  self.firstLoad == true &&
                  self.selectedUnitDetails.status != 'Moving'))
            ) {
              self.firstLoad = false;
              self.loadStreetView = true;
              self.currentDisplayedAssetId = assetId;
              self.streetMap = new google.maps.StreetViewPanorama(
                self.$refs.map2,
                {
                  position: {
                    lat: self.selectedUnitDetails.lat,
                    lng: self.selectedUnitDetails.lng,
                  },

                  pov: {
                    heading: 180 - self.selectedUnitDetails.heading || 0,
                    pitch: 0,
                  },
                },
              );
            }

            self.isLoading = false;

            self.isLoading2 = false;
            self.selectedUnitDisplay = true;
            self.singleListener = setTimeout(() => {
              self.displayDetails(assetId);
            }, 60000);
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
  },
  created() {},
  destroyed() {
    if (this.listener) {
      clearTimeout(this.listener);
    }
    if (this.singleListener) {
      clearTimeout(this.singleListener);
    }
  },
};
</script>

<style>
#map {
  height: 99vh;
}
#map2 {
  height: 18vh;
}
.hide {
  visibility: hidden !important;
}
@-webkit-keyframes inputOn {
  from {
    background-color: #3e1cff;
  }
  to {
    background-color: inherit;
  }
}
@-moz-keyframes inputOn {
  from {
    background-color: #3e1cff;
  }
  to {
    background-color: inherit;
  }
}
@-o-keyframes inputOn {
  from {
    background-color: #3e1cff;
  }
  to {
    background-color: inherit;
  }
}
@keyframes inputOn {
  from {
    background-color: #3e1cff;
  }
  to {
    background-color: inherit;
  }
}
.inputOn {
  -webkit-animation: inputOn 2s infinite; /* Safari 4+ */
  -moz-animation: inputOn 2s infinite; /* Fx 5+ */
  -o-animation: inputOn 2s infinite; /* Opera 12+ */
  animation: inputOn 2s infinite; /* IE 10+ */
}

.e-multiselect input.e-dropdownbase::placeholder {
  color: black;
}
@import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
</style>
